export const getObjectValueArrayForKey = (obj: any, key: string) => {
  let values: any[] = [];

  const search = (obj: any) => {
    if (obj && typeof obj === 'object') {
      Object.entries(obj).forEach(([k, v]) => {
        if (typeof v === 'object') {
          search(v);
        } else if (k === key) {
          values.push(v);
        }
      });
    }
  };

  search(obj);

  return values;
};
